export default __webpack_public_path__ + "static/media/icon_browser.b2e588b7.svg";